<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <h2 class="brand-text text-primary ml-1">
          Diko
        </h2>
      </b-link>
      <!-- /Brand logo-->
      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->
      <!-- Register-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            DİKO Hesabınızı Oluşturun
          </b-card-title>
          <b-card-text class="mb-2" />
          <!-- form -->
          <validation-observer ref="registerForm">
            <b-form class="auth-register-form mt-2">
              <!-- name -->
              <b-form-group
                label="Ad"
                label-for="register-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Ad"
                  rules="required"
                >
                  <b-form-input
                    id="register-name"
                    v-model="name"
                    name="register-name"
                    :formatter="trTitleCase"
                    :state="errors.length > 0 ? false : null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- surname -->
              <b-form-group
                label="Soyad"
                label-for="register-surname"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Soyad"
                  rules="required"
                >
                  <b-form-input
                    id="register-surname"
                    v-model="surname"
                    name="register-surname"
                    :formatter="trTitleCase"
                    :state="errors.length > 0 ? false : null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- phone -->
              <b-form-group
                :label="$t('Mobile Phone Number')"
                label-for="register-phone"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Phone Number')"
                  rules="required"
                >
                  <b-form-input
                    id="register-phone"
                    v-model="phone"
                    name="register-phone"
                    :formatter="phoneFormatter"
                    :state="errors.length > 0 || (phone && !phoneValid) ? false : null"
                    placeholder="(5__) ___ __ __"
                    @input="phoneChanged"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                  <small
                    v-if="phone && !phoneValid"
                    class="text-danger d-block"
                  >{{ $t('Enter a valid mobile phone number') }}</small>
                </validation-provider>
              </b-form-group>
              <!-- email (required, confirmed by OTP after registration) -->
              <b-form-group
                :label="$t('Email')"
                label-for="register-email"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Email')"
                  rules="required|email"
                >
                  <b-form-input
                    id="register-email"
                    v-model="userEmail"
                    name="register-email"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('Enter your email address...')"
                  />
                  <small class="text-danger">{{ $t(errors[0]).replaceAll("Email", "E-posta")
                  }}</small>
                </validation-provider>
              </b-form-group>
              <!-- password -->
              <b-form-group
                label-for="register-password"
                label="Şifre"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Password')"
                  rules="required|min:8"
                  :custom-messages="{ min: $t('400006') }"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 || (password && !passwordValid) ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="register-password"
                      v-model="password"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      :state="errors.length > 0 || (password && !passwordValid) ? false : null"
                      name="register-password"
                      placeholder="············"
                      aria-describedby="register-password-feedback"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIcon"
                        class="cursor-pointer"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small
                    id="register-password-feedback"
                    class="text-danger"
                  >{{ password && !passwordValid ? $t('400006') : $t(errors[0]).replaceAll("Password", "Şifre")
                  }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <label>Meslek</label>
                <b-form-select v-model="field">
                  <b-form-select-option value="">
                    Seçiniz
                  </b-form-select-option>
                  <b-form-select-option value="psychiatry">
                    Psikiyatri
                  </b-form-select-option>
                  <b-form-select-option value="psychology">
                    Psikoloji
                  </b-form-select-option>
                  <b-form-select-option value="counseling">
                    PDR
                  </b-form-select-option>
                  <b-form-select-option value="other">
                    Diğer
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Yasal metinler"
                  rules="required"
                >
                  <b-form-checkbox
                    id="register-privacy-policy"
                    v-model="status"
                    name="membership-agreement"
                  >
                    <b-link
                      :to="membershipAgreementRoute"
                      target="_blank"
                      @click.stop
                    >
                      DİKO Üyelik Sözleşmesi'ni
                    </b-link>,
                    <b-link
                      :to="kvkkNoticeRoute"
                      target="_blank"
                    >
                      KVKK Aydınlatma Metni'ni
                    </b-link>
                    ve
                    <b-link
                      :to="marketingConsentRoute"
                      target="_blank"
                    >
                      Açık Rıza Metni'ni
                    </b-link>
                    okudum ve kabul ediyorum.
                  </b-form-checkbox>
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
              <b-button
                variant="primary"
                :title="
                  !status ||
                    field == '' ||
                    password == '' ||
                    name == '' ||
                    surname == '' ||
                    phone == '' ||
                    userEmail == ''
                    ? $t('You must agree to Terms of Privacy')
                    : ''
                "
                :disabled="
                  !status ||
                    field == '' ||
                    !passwordValid ||
                    name == '' ||
                    surname == '' ||
                    !phoneValid ||
                    userEmail == '' ||
                    !emailValid ||
                    registrationPending
                "
                block
                type="submit"
                @click.prevent="validationForm"
              > {{ $t('Verify My Phone and Create My Account') }} </b-button>
            </b-form>
            <b-alert
              v-if="registrationError"
              show
              variant="danger"
              class="mt-1"
            >
              {{ registrationError }}
            </b-alert>
          </validation-observer>
          <p class="text-center mt-2">
            <span>Zaten hesabınız var mı?</span>
            <b-link :to="{ name: 'auth-login' }">
              <span>&nbsp;Giriş yapın</span>
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>
    <phone-otp-modal
      v-if="otpOpen"
      :phone="phone"
      purpose="register"
      @verified="registerWithPhone"
      @cancelled="otpOpen = false"
    />
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BAlert,
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
  BFormSelect,
  BFormSelectOption,
} from 'bootstrap-vue'
import { required, email, min } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import PhoneOtpModal from '@/components/PhoneOtpModal.vue'
import { formatPhone, isValidPhone } from '@/libs/phone'
import { isValidEmailStrict } from '@/libs/email'
import { OTP_ERROR_KEYS, OTP_ERROR_KEYS_BY_CODE } from '@/libs/otpI18nKeys'
import { trTitleCase } from '@/libs/textFormat'

export default {
  components: {
    BAlert,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    // validations
    ValidationProvider,
    ValidationObserver,
    PhoneOtpModal,
    // select
    BFormSelect,
    BFormSelectOption,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: false,
      name: '',
      surname: '',
      userEmail: '',
      password: '',
      field: '',
      phone: '',
      phoneToken: null,
      otpOpen: false,
      registrationPending: false,
      registrationError: '',
      sideImg: require('@/assets/images/pages/register-v2.svg'),
      // validation
      required,
      email,
      min,
    }
  },
  computed: {
    phoneValid() {
      return isValidPhone(this.phone)
    },
    passwordValid() {
      return typeof this.password === 'string' && this.password.length >= 8
    },
    // WP1: email is now required at registration; mirrors phoneValid so the
    // submit button's eager disabled/title guard can gate on it the same way.
    // Strict ASCII matcher shared with the server rule — the old lax regex let
    // "tugçeustun81@gmail.com" through and its mail silently bounced.
    emailValid() {
      return isValidEmailStrict(this.userEmail || '')
    },
    membershipAgreementRoute() {
      return {
        name: 'legal-document',
        params: { slug: 'diko-uyelik-sozlesmesi' },
      }
    },
    marketingConsentRoute() {
      return {
        name: 'legal-document',
        params: { slug: 'pazarlama-acik-riza-metni' },
      }
    },
    kvkkNoticeRoute() {
      return {
        name: 'legal-document',
        params: { slug: 'kvkk-aydinlatma-metni' },
      }
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created() {
    const newMetaOgImg = document.createElement('meta')
    newMetaOgImg.setAttribute('property', 'og:image')
    newMetaOgImg.setAttribute(
      'content',
      `https://app.dikoturkiye.com${require('@/assets/share.jpg')}`,
    )
    document.head.appendChild(newMetaOgImg)
    const newMetaOgImgType = document.createElement('meta')
    newMetaOgImgType.setAttribute('property', 'og:image:type')
    newMetaOgImgType.setAttribute('content', 'image/jpeg')
    document.head.appendChild(newMetaOgImgType)
  },
  methods: {
    trTitleCase,
    /* eslint-disable */
    phoneFormatter: formatPhone,
    phoneChanged() {
      this.phoneToken = null;
      this.registrationError = "";
    },
    /* eslint-enable */
    validationForm() {
      /* eslint-disable */
      if (!this.phoneValid || !this.passwordValid) return;
      this.$refs.registerForm.validate().then((success) => {
        if (!success || !this.status || !this.passwordValid) return;
        this.registrationError = "";
        // A token retained from a completed OTP is still valid for the same
        // phone; retry registration directly instead of forcing a new OTP.
        if (this.phoneToken) this.submitRegistration();
        else this.otpOpen = true;
      });
      /* eslint-enable */
    },
    registerWithPhone(result) {
      /* eslint-disable */
      this.otpOpen = false;
      this.phoneToken = result.phoneToken;
      this.submitRegistration();
      /* eslint-enable */
    },
    // vue-router 3.1+ returns a promise that rejects on an aborted or
    // redirected navigation. Swallow exactly that: a failed navigation must
    // never be reported as a failed registration.
    navigateIgnoringAbort(location) {
      const navigation = this.$router.push(location)
      if (navigation && typeof navigation.catch === 'function') navigation.catch(() => {})
      return navigation
    },
    submitRegistration() {
      /* eslint-disable */
      // In-flight guard: a retained phoneToken plus rapid re-clicks must never
      // issue concurrent register calls (exactly-one-call contract).
      if (this.registrationPending) return;
      if (!this.passwordValid) {
        this.registrationError = this.$t('400006');
        return;
      }
      this.registrationPending = true;
      useJwt.register({
        name: this.name,
        surname: this.surname,
        email: this.userEmail,
        password: this.password,
        field: this.field,
        referrer: this.$route.query.referrer,
        phoneToken: this.phoneToken,
      }).then(() => {
        this.registrationPending = false;
        // A guard redirect or duplicate navigation rejects this promise; that
        // is not a registration failure and must never reach the catch below.
        this.navigateIgnoringAbort({ name: 'account-settings' });
      }).catch((error) => {
        this.registrationPending = false;
        // A credential-state rejection happens only after the server already
        // answered 201: the account, its session cookie, and its mails all
        // exist, and only the local credential install failed. Retrying would
        // spend nothing and fail with 400016 (the one-time phoneToken is
        // consumed), so say what actually happened and send the user to login
        // instead of inviting a retry.
        if (!error.response && error.name === "CredentialStateError") {
          this.phoneToken = null;
          this.registrationError = this.$t("Your account was created, but the session could not be started. Please sign in.");
          this.navigateIgnoringAbort({ name: 'auth-login' });
          return;
        }
        const data = (error.response && error.response.data) || {};
        const errorCode = String(data.errorCode || "");
        if (errorCode === "400016" || errorCode === "400017") this.phoneToken = null;
        const mappedKey = OTP_ERROR_KEYS_BY_CODE[Number(errorCode)];
        // Only a mapped server code may claim a phone-verification problem;
        // an unmapped or transport-level failure said nothing about the phone.
        this.registrationError = mappedKey
          ? this.$t(mappedKey)
          : data.message
            || (error.response
              ? this.$t(OTP_ERROR_KEYS.verificationRequired)
              : this.$t("Registration could not be completed. Please try again."));
      });
      /* eslint-enable */
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
